{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try. You can manage your bots from this page or create new ones using the 'Add Bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "COUNT": "{n} bot | {n} bots",
    "SEARCH_PLACEHOLDER": "Search bots...",
    "NO_RESULTS": "No bots found matching your search",
    "GLOBAL_BOT": "System bot",
    "GLOBAL_BOT_BADGE": "System",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot avatar deleted successfully",
      "ERROR_DELETE": "Error deleting bot avatar, please try again"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "SUBMIT": "புதுப்பிப்பு",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot"
    },
    "ADD": {
      "TITLE": "Add Bot",
      "CANCEL_BUTTON_TEXT": "ரத்துசெய்",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Add Bot' button.",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Bot Details",
        "URL": "வெப்ஹூக் URL",
        "ACTIONS": "செயல்கள்"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "நீக்குதலை உறுதிப்படுத்தவும்",
        "MESSAGE": "Are you sure you want to delete {name}?",
        "YES": "Yes, Delete",
        "NO": "No, Keep"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "திருத்து",
      "TITLE": "Edit bot",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "ரகசியம் கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது",
      "TOGGLE": "ரகசியத்தை காண்பிக்க/மறைக்கவும்",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "முடிந்தது",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "அணுகுவதற்கான டோக்கன்",
      "DESCRIPTION": "Copy the access token and save it securely",
      "COPY_SUCCESSFUL": "Access token copied to clipboard",
      "RESET_SUCCESS": "Access token regenerated successfully",
      "RESET_ERROR": "Unable to regenerate access token. Please try again"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatar"
      },
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Enter bot name",
        "REQUIRED": "Bot name is required"
      },
      "DESCRIPTION": {
        "LABEL": "Description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "WEBHOOK_URL": {
        "LABEL": "வெப்ஹூக் URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL is required"
      },
      "ERRORS": {
        "NAME": "Bot name is required",
        "URL": "Webhook URL is required",
        "VALID_URL": "Please enter a valid URL starting with http:// or https://"
      },
      "CANCEL": "ரத்துசெய்",
      "CREATE": "Create Bot",
      "UPDATE": "Update Bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configure a webhook bot to integrate with your custom services. The bot will receive and process events from conversations and can respond to them."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot"
    }
  }
}
